var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9993 27.3334C6.63535 27.3334 0.666016 21.364 0.666016 14C0.666016 6.63602 6.63535 0.666687 13.9993 0.666687C21.3633 0.666687 27.3327 6.63602 27.3327 14C27.3327 21.364 21.3633 27.3334 13.9993 27.3334ZM12.666 12.6667H7.33268V15.3334H12.666V20.6667H15.3327V15.3334H20.666V12.6667H15.3327V7.33335H12.666V12.6667Z",
    fill: "#D4D3D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.eb933c6d91eedef51569dfe570cc0c5b.svg";
export { ForwardRef as ReactComponent };